import { useEffect } from "react";
import { useCart } from "../../hooks/useCart";
import { AnimatedNumber } from "../cardItem/AnimatedNumber";
import { useDispatch, useSelector } from "react-redux";
import { setRecentlyAddedFalse } from "../../store/slices/modalSlice";

const CartPopup = () => {
  const {
    data,
    totalItemInCart,
    oldTotalAmount,
    totalAmountOfCartItem,
    updateCartQuantity,
    openModel,
    cartRedirect,
  } = useCart();

  const dispatch = useDispatch();

  const recentlyAddedd = useSelector(
    (state: { modal: { recentlyAdded: boolean } }) => state.modal.recentlyAdded
  );

  useEffect(() => {
    import("./cart-popup.css");
    const timer = setTimeout(() => {
      dispatch(setRecentlyAddedFalse());
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* <>
        cart pop {data.length} {recentlyAddedd ? "jj" : "2555"}
      </> */}
      {recentlyAddedd && data.length > 0 && (
        <div className="cart-popup">
          <div className="cart-header d-flex justify-content-start gap-2 align-items-center bg-white border-bottom">
            <h4 className="font-16 text-black ff-bold mb-0">My Cart</h4>
            <span className="font-12 text-black">
              {totalItemInCart} Service {data?.length > 1 ? "s" : ""}
            </span>
          </div>

          <div className="cart-body-1 bg-white p-3 d-flex flex-column">
            <div className="bg-beige gap-2 d-flex align-items-center px-3 py-2">
              <i className="fa fa-check-circle tick-icon font-12"></i>
              <span className="ml-2 font-12">
                <span className="font-12 ff-semibold text-black rounded">
                  {totalItemInCart} Service{data?.length > 1 ? "s" : ""}
                </span>
                added to your cart
              </span>
            </div>

            <div className="cart-items-list d-flex flex-column">
              {data
                .reverse()
                .map(
                  ({
                    productId,
                    serviceImage,
                    serviceName,
                    TotalAmount,
                    serviceid,
                    PriceRecordId,
                    Quantity,
                  }) => (
                    <div
                      key={`cartpopup-${productId}`}
                      className="cart-item d-flex align-items-start gap-3 border-bottom"
                    >
                      <img
                        src={serviceImage}
                        alt={serviceName}
                        className="cart-item-img"
                      />
                      <div className="cart-item-info ml-2">
                        <p className="font-12 ff-semibold text-black">
                          {serviceName}
                        </p>
                        <p className="font-10 text-black">
                          <span className="ff-currency ff-medium font-16">
                            
                          </span>

                          <span className="ff-bold">
                            {TotalAmount.toFixed(2)}
                          </span>
                        </p>

                        <div className="d-flex align-items-center justify-content-center add-cart-btn-main mt-2">
                          <button
                            className="bt-mi"
                            onClick={() =>
                              updateCartQuantity(
                                serviceid,
                                PriceRecordId,
                                "minus"
                              )
                            }
                          >
                            -
                          </button>
                          <span onClick={() => openModel(serviceid)}>
                            <div className="w-8">
                              <AnimatedNumber value={Quantity} />
                            </div>
                          </span>
                          <button className="bt-plu">+</button>
                        </div>
                      </div>
                    </div>
                  )
                )}
            </div>
          </div>

          <div className="footer-like-section bg-white">
            <a
              className="btn btn-primary flow-btn py-3 d-flex justify-content-between align-items-center mx-2"
              style={{
                cursor: "pointer",
                backgroundColor: "rgb(110, 66, 229)",
                border: "none",
              }}
              onClick={cartRedirect}
            >
              <span className="font-weight-bold font-14">
                <span className="ff-semibold">
                  <span className="ff-currency ff-medium  font-16"></span>{" "}
                  {totalAmountOfCartItem.toFixed(2)}
                </span>
              </span>
              <span className="font-14 ff-semibold">View Cart</span>
            </a>

            {oldTotalAmount > totalAmountOfCartItem && (
              <div className="font-11 ff-semibold text-center mx-2 bg-3 glair-wrap mt-3">
                <span className="ms-1 glair">
                  Yay! You just saved{" "}
                  <span className="font-11 ff-bold">
                    <span className="ff-currency ff-medium  font-16"></span>
                    {Number(oldTotalAmount - totalAmountOfCartItem).toFixed(2)}
                  </span>{" "}
                  on your bill!! <br />
                  what a steal!
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CartPopup;
